// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9MEuw","rootMobile":"styles_rootMobile___DVcs"};